<template>
  <div class="country-form">
    <h2 class="text-campton-bold">{{ $gettext('Create an account') }}</h2>
    <p>
      {{ $gettext('You want to create a new account with your Google email. Please tell us your business location.') }}
    </p>
    <b-form @submit.prevent="completeSignIn" class="gk-clear-form">

      <CountrySelector v-if="!loading && businesslocation" v-model="businesslocation" />

      <div style="padding-top: 0.5rem; width: 100%;">
        <GekkoButton
          type="submit"
          :text="$gettext('Create account')"
          variant="primary"
          class="w-100 text-campton-book position-relative"
          size="xl"
          :loading="creatingAccount"
          :disabled="!businesslocation"
        />
      </div>
    </b-form>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"

import CountrySelector from "@/components/signup/CountrySelector"
import GekkoButton from "@/components/GekkoButton"

export default {
  name: 'SignupCountryForm',
  components: {
    GekkoButton,
    CountrySelector
  },
  props: {

  },
  data () {
    return {
      loading: true,
      creatingAccount: false,
      businesslocation: '',
      preferredlanguage: null
    }
  },
  computed: {
    ...mapGetters({
      userCountry: 'signup/getUserCountry',
      userLanguage: 'signup/getUserLanguage',
      getGoogleCallbackData: "auth/getGoogleCallbackData",
      getAppleCallbackData: "auth/getAppleCallbackData"
    }),
  },
  created () {
    this.setupData()
  },
  mounted () {
  },
  methods: {
    ...mapActions({
      geoLocateUserIp: 'signup/geoLocateUserIp',
      processGoogleCredentials: 'auth/processGoogleCredentials',
      processAppleCredentials: 'auth/processAppleCredentials'
    }),
    setupData () {
      this.loading = true
      this.geoLocateUserIp().then(() => {
        this.preferredlanguage = this.$route.params.language || this.userLanguage
        this.businesslocation = this.userCountry
        this.loading = false
      })
    },
    completeSignIn () {
      this.creatingAccount = true

      if (this.getAppleCallbackData !== null) {
        this.processAppleCredentials({ country: this.businesslocation, preferred_language: this.preferredlanguage }).then(() => {
          this.$emit('authorised', false)
        }).catch((error) => {
          console.log('SignupCouyntryForm::completeSignIn()', error)
        })
      } else if (this.getGoogleCallbackData !== null) {
        this.processGoogleCredentials({ country: this.businesslocation, preferred_language: this.preferredlanguage }).then(() => {
          this.$emit('authorised', false)
        }).catch((error) => {
          console.log('SignupCouyntryForm::completeSignIn()', error)
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>